require('./polyfill');
const { Connect, Config } = require('@vkontakte/superappkit');

function vkAuth(appId, superAppToken, nextUrl = null) {
  Config.init({
    appId: +appId,
    superAppToken,
  });
  Connect.redirectAuth({
    url: `${document.location.protocol}//${document.location.host}/api/vk/exchange-token/`,
    state: nextUrl || document.location.pathname,
    screen: 'phone',
  });
}
window.vkAuth = vkAuth;

const extend = require('xtend/mutable');

// dependencies for scripts called externally,
// e.g. Google Analytics scripts
extend(window, {
  q: require('queried'),
  on: require('emmy/on'),
  once: require('emmy/once'),
  delegate: require('emmy/delegate'),
  forEach: require('object-foreach'),
  InViewFactory: require('kudago-in-view'),
  throttle: require('lodash/throttle'),
  keys: require('key-name'),
  isBrowserWhitelisted: require('./components/is-browser-whitelisted'),
  getUserConfig: require('./components/get-user-config'),
  specialProjectsCounterHelper: require('./components/special-projects-counter-helper'),
  createMailruPixel: require('./components/mailru-pixel'),
});
